import { BASE_PATH } from '../../shared/types';
import { reportingFetch } from './clientErrors';

export const API = `${BASE_PATH}/api`;

export class ApiError extends Error {
  constructor(public status: number, public code: string, public issues?: import('../../shared/pdf/errors').PdfEngineIssue[]) {
    super(`${status} ${code}`);
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  // Participant submission requests carry no cookies and have a deadline; a file upload gets longer.
  const participant = path === '/public/submit' || path === '/public/submission-status' || path.startsWith('/public/submission/');
  const res = await reportingFetch(`${API}${path}`, {
    method,
    headers: body !== undefined && !(body instanceof FormData) ? { 'content-type': 'application/json' } : undefined,
    body: body instanceof FormData ? body : body !== undefined ? JSON.stringify(body) : undefined,
    credentials: participant ? 'omit' : 'same-origin',
    ...(participant ? { signal: AbortSignal.timeout(path === '/public/submission/file' ? 180_000 : 60_000) } : {}),
  });
  if (res.status === 204) return undefined as T;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, (data as { error?: string }).error ?? 'error', (data as {issues?: import('../../shared/pdf/errors').PdfEngineIssue[]}).issues);
  return data as T;
}

export const api = {
  get: <T>(p: string) => request<T>('GET', p),
  post: <T>(p: string, b?: unknown) => request<T>('POST', p, b),
  postForm: <T>(p: string, b: FormData) => request<T>('POST', p, b),
  put: <T>(p: string, b?: unknown) => request<T>('PUT', p, b),
  del: <T>(p: string, b?: unknown) => request<T>('DELETE', p, b),
};
